export default {
  entry: 'path/to/entry/index.js',
  plugins: [['mock-plugin', { mockOption: 'some-option' }]],
}
